{
  "familyId": "TAA-SIGNAALWOORD",
  "questions": [
    {
      "id": "TAA-SIGNAALWOORD-001",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "multiple_choice",
      "question": "Welk signaalwoord geeft een tegenstelling aan?",
      "context": "Het regende hard. Toch gingen we naar buiten.",
      "options": ["Toch", "Hard", "Naar", "We"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Signaalwoorden: tegenstelling",
            "content": "Tegenstellingswoorden geven aan dat iets anders is dan verwacht. Voorbeelden: toch, maar, echter, hoewel, ondanks, daarentegen. 'Toch' geeft aan: ondanks de regen gingen ze naar buiten.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "signal_word_contrast",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.79,
      "feedback": {
        "explanationText": "Signaalwoorden geven de relatie tussen zinnen aan. De eerste zin beschrijft regen (oorzaak om binnen te blijven). De tweede zin beschrijft het tegenovergestelde (naar buiten gaan). 'Toch' is het signaalwoord dat deze tegenstelling aangeeft.",
        "solutionSteps": [
          "Zoek het signaalwoord: 'toch'",
          "Eerste zin: regen → verwachting: binnen blijven",
          "Tweede zin: toch naar buiten → tegenstelling",
          "'Toch' = signaalwoord voor tegenstelling"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Toch' is een signaalwoord voor tegenstelling — het geeft aan dat iets anders gaat dan verwacht.",
          "1": "Je dacht waarschijnlijk dat 'hard' een signaalwoord is. Maar 'hard' is een bijwoord dat beschrijft hoe het regende. Onthoud: signaalwoorden verbinden zinnen, ze beschrijven niet.",
          "2": "Je dacht waarschijnlijk dat 'naar' een signaalwoord is. Maar 'naar' is een voorzetsel (richting). Onthoud: signaalwoorden geven de relatie tussen zinnen aan.",
          "3": "Je dacht waarschijnlijk dat 'we' een signaalwoord is. Maar 'we' is een voornaamwoord (persoon). Onthoud: signaalwoorden zijn woorden als maar, toch, want, dus."
        }
      }
    },
    {
      "id": "TAA-SIGNAALWOORD-002",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "multiple_choice",
      "question": "Welk signaalwoord geeft een oorzaak-gevolg aan?",
      "context": "De weg was glad. Daardoor slipte de auto.",
      "options": ["Daardoor", "Was", "Glad", "De"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Signaalwoorden: oorzaak-gevolg",
            "content": "Oorzaak-gevolgwoorden verbinden een reden met een resultaat. Voorbeelden: daardoor, daarom, want, omdat, hierdoor, dus. 'Daardoor' geeft aan: de gladde weg (oorzaak) → de auto slipte (gevolg).",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "signal_word_cause_effect",
      "variantIndex": 2,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Zoek het woord dat oorzaak en gevolg verbindt. Oorzaak = de weg was glad. Gevolg = de auto slipte. 'Daardoor' verbindt deze twee: de gladde weg veroorzaakte het slippen.",
        "solutionSteps": [
          "Oorzaak: de weg was glad",
          "Gevolg: de auto slipte",
          "'Daardoor' verbindt oorzaak en gevolg"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Daardoor' is een signaalwoord voor oorzaak-gevolg.",
          "1": "Je dacht waarschijnlijk dat 'was' een signaalwoord is. Maar 'was' is een werkwoord (koppelwerkwoord). Onthoud: signaalwoorden verbinden zinnen, werkwoorden geven handelingen aan.",
          "2": "Je dacht waarschijnlijk dat 'glad' een signaalwoord is. Maar 'glad' is een bijvoeglijk naamwoord. Onthoud: signaalwoorden zijn woorden als daardoor, daarom, want, omdat.",
          "3": "Je dacht waarschijnlijk dat 'de' een signaalwoord is. Maar 'de' is een lidwoord. Onthoud: signaalwoorden geven de relatie tussen zinnen aan."
        }
      }
    },
    {
      "id": "TAA-SIGNAALWOORD-003",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "text_highlight",
      "question": "Klik op het signaalwoord in deze zin:",
      "context": "We wilden gaan zwemmen, maar het zwembad was gesloten.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "We wilden gaan zwemmen, maar het zwembad was gesloten.",
        "correctHighlights": [{"start": 24, "end": 28}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Signaalwoord herkennen",
            "content": "'Maar' is een signaalwoord voor tegenstelling. Het verbindt twee tegengestelde ideeën: willen zwemmen ↔ zwembad gesloten.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "signal_word_highlight",
      "variantIndex": 3,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "'Maar' is het signaalwoord. Het geeft een tegenstelling aan: ze wilden zwemmen (verwachting) ↔ het zwembad was gesloten (werkelijkheid).",
        "solutionSteps": [
          "Zoek het signaalwoord: 'maar'",
          "Verwachting: willen zwemmen",
          "Werkelijkheid: zwembad gesloten",
          "'Maar' = tegenstelling"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Maar' is het signaalwoord (tegenstelling)."
        }
      }
    },
    {
      "id": "TAA-SIGNAALWOORD-004",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "matching",
      "question": "Koppel elk signaalwoord aan het juiste type verband.",
      "context": null,
      "options": ["Match 1", "Match 2", "Match 3", "Match 4"],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["Omdat", "Maar", "Bovendien", "Daarna"],
        "rightItems": ["Oorzaak-gevolg", "Tegenstelling", "Opsomming", "Tijd"],
        "correctMatches": {"0": 0, "1": 1, "2": 2, "3": 3}
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Soorten signaalwoorden",
            "content": "Oorzaak-gevolg: omdat, want, daardoor. Tegenstelling: maar, toch, echter. Opsomming: bovendien, ook, daarnaast. Tijd: daarna, vervolgens, ten slotte.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "signal_word_matching",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Omdat = oorzaak-gevolg (geeft een reden). Maar = tegenstelling (geeft een contrast). Bovendien = opsomming (voegt iets toe). Daarna = tijd (geeft volgorde aan).",
        "solutionSteps": [
          "Omdat → oorzaak-gevolg (waarom?)",
          "Maar → tegenstelling (onverwacht)",
          "Bovendien → opsomming (wat nog meer?)",
          "Daarna → tijd (wanneer?)"
        ]
      }
    },
    {
      "id": "TAA-SIGNAALWOORD-005",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "multiple_choice",
      "question": "Welk signaalwoord past het best? 'Eerst maakten we huiswerk. ___ gingen we buiten spelen.'",
      "context": null,
      "options": ["Daarna", "Omdat", "Maar", "Want"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Signaalwoord kiezen",
            "content": "De zinnen beschrijven een volgorde in tijd: eerst huiswerk, dan buiten spelen. 'Daarna' is het juiste tijdssignaalwoord.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "signal_word_choose",
      "variantIndex": 5,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Bepaal het verband tussen de zinnen. 'Eerst' geeft aan dat er een volgorde is. Na het huiswerk volgt buiten spelen. 'Daarna' is het tijdssignaalwoord dat deze volgorde aangeeft.",
        "solutionSteps": [
          "'Eerst' → er is een volgorde",
          "Na huiswerk volgt buiten spelen",
          "'Daarna' = tijdssignaalwoord voor volgorde"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Daarna' geeft de tijdsvolgorde aan: eerst huiswerk, daarna buiten spelen.",
          "1": "Je dacht waarschijnlijk dat 'omdat' past. Maar 'omdat' geeft een reden aan, en de zinnen beschrijven een volgorde, geen oorzaak. Onthoud: volgorde = daarna, vervolgens.",
          "2": "Je dacht waarschijnlijk dat 'maar' past. Maar 'maar' geeft een tegenstelling aan, en er is hier geen tegenstelling. Onthoud: beide activiteiten gebeuren gewoon na elkaar.",
          "3": "Je dacht waarschijnlijk dat 'want' past. Maar 'want' geeft een reden aan, en de zinnen beschrijven een volgorde. Onthoud: volgorde = daarna, vervolgens."
        }
      }
    },
    {
      "id": "TAA-SIGNAALWOORD-009",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "true_false_series",
      "question": "Zijn deze stellingen over signaalwoorden waar of onwaar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "'Daarom' is een signaalwoord voor een oorzaak of reden.", "isTrue": true },
          { "text": "'Maar' is een signaalwoord voor een opsomming.", "isTrue": false },
          { "text": "'Ten eerste' is een signaalwoord voor een volgorde.", "isTrue": true },
          { "text": "'Omdat' is een signaalwoord voor een tegenstelling.", "isTrue": false }
        ]
      },
      "conceptId": "signal_word_true_false",
      "variantIndex": 9,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Signaalwoorden geven een verband aan. 'Daarom' geeft een reden aan. 'Maar' geeft een tegenstelling aan (geen opsomming). 'Ten eerste' geeft een volgorde aan. 'Omdat' geeft een reden aan (geen tegenstelling).",
        "solutionSteps": [
          "'Daarom' = reden (Waar)",
          "'Maar' = tegenstelling, niet opsomming (Onwaar)",
          "'Ten eerste' = volgorde (Waar)",
          "'Omdat' = reden, niet tegenstelling (Onwaar)"
        ]
      }
    },
    {
      "id": "TAA-SIGNAALWOORD-010",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "categorize",
      "question": "Sorteer de signaalwoorden bij het juiste verband.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Tegenstelling", "Opsomming", "Oorzaak/Reden"],
        "items": [
          { "text": "maar", "correctCategory": 0 },
          { "text": "en", "correctCategory": 1 },
          { "text": "omdat", "correctCategory": 2 },
          { "text": "echter", "correctCategory": 0 },
          { "text": "ook", "correctCategory": 1 },
          { "text": "want", "correctCategory": 2 }
        ]
      },
      "conceptId": "signal_word_categorize",
      "variantIndex": 10,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Tegenstelling: maar, echter, toch. Opsomming: en, ook, bovendien. Oorzaak/reden: omdat, want, daarom.",
        "solutionSteps": [
          "Tegenstelling: woorden die een contrast aangeven (maar, echter)",
          "Opsomming: woorden die iets toevoegen (en, ook)",
          "Oorzaak/reden: woorden die uitleggen waarom (omdat, want)"
        ]
      }
    }
  ]
}